<script>
export default {
  beforeRouteEnter(from, to, next) {
    if (sessionStorage.getItem('_role')?.includes('RpsAdministrator')) {
      return next();
    }

    return next('/');
  },
};
</script>
